import { Component } from '@angular/core';

@Component({
	templateUrl: './panneau-lecture-terminal.component.html',
	styleUrls: ['./panneau-lecture-terminal.component.scss'],
})
export class PanneauLectureTerminalComponent {

	constructor() { }

}
